<template>
  <div class="container">
    <div class="row">


      <m-product-wrapper
          :wait-for-category="waitForCategory"
          :product-categories="productCategories"
          :product-category-column="categoryColumn"
          :per-page="perPage">
        <template v-slot="{products,pagination,changePageFunction}">
          <div class="col-12 archive-items">

            <main dir="ltr">
              <div v-for="product in products" class="card product-card-fantasy-900 position-relative"
                   :class="`product-card-${product.id}`"
                   @click="selectImage(`product-card-${product.id}`)">
                <img :src="product.thumbnail" :alt="product.name" :data-product-id="product.id"
                     class="product-card-fantasy-900-image "/>
                <div class="d-none product-card-fantasy-900-button position-absolute">
                  <m-a target="_blank" :href="{name:'Product',params:{name:product.raw_link}}">
                    <button class="btn show-more-button">
                      <span class="text-dark">مشاهده</span>
                    </button>
                  </m-a>
                </div>
              </div>

            </main>

          </div>
        </template>
      </m-product-wrapper>


    </div>
  </div>
</template>

<script>
import mProductWrapper from "../../../Wrappers/ProductWrapper";
import mA from '../../../Tags/A.vue'

export default {
  name: "ProductsFantasy900",
  components: {
    mProductWrapper,
    mA,
  },
  props: {
    perPage: {
      default: 12,
    },
    productCategories: {
      type: Object,
      default: null
    },
    waitForCategory: {
      type: Boolean,
      default: false
    },
    categoryColumn: {
      type: String,
      default: 'slug'
    },
  },
  data() {
    return {}
  },
  methods: {
    selectImage(myCardName) {
      const cards = document.querySelectorAll('.card.product-card-fantasy-900');
      const cardsButton = document.querySelectorAll('.card.product-card-fantasy-900-button');

      let myCard = document.getElementsByClassName(myCardName)[0]
      for (let card of cards) {
        card.classList.remove('selected');
        card.classList.add('blur');
      }

      for (let card of cardsButton) {
        card.classList.remove('d-none');
      }

      myCard.classList.add('selected');
      myCard.classList.remove('blur');
      let selectedCardButton = document.querySelector(`.${myCardName} .product-card-fantasy-900-button`);
      selectedCardButton.classList.remove('d-none')
    }

  },
  mounted() {

    document.addEventListener('click', function (e) {
      var targetElement = e.target;

      if (targetElement.tagName.toLowerCase() != 'img') {
        const cards = document.querySelectorAll('.product-card-fantasy-900');
        for (let card of cards) {
          card.classList.remove('selected');
          card.classList.remove('blur');
        }

        const cardsButton = document.querySelectorAll('.product-card-fantasy-900-button');
        for (let card of cardsButton) {
          card.classList.add('d-none');
        }


      }


    });
  },
}
</script>

<style scoped>
main {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.card {
  cursor: pointer;
  transition: 0.3s;
  perspective: 600px;
  position: relative;
  height: 400px;
  width: 200px;
  background-color: transparent !important;
  border: none !important;

}

img {
  transition: 0.3s;
  user-select: none;
  position: absolute;
  width: 300px;
  border-radius: 20px;
  box-shadow: -20px 0px 20px rgba(0, 0, 0, 0.4);
  transform: rotateY(40deg);
}

.card:last-child {
  margin-right: 100px;
}

.card:hover {
  width: 250px;
}

.card:hover > img {
  transform: rotateY(20deg);
  box-shadow: -5px 0px 5px rgba(0, 0, 0, 0.8);
}

.card.selected {
  width: 250px;
  z-index: 5;
  scale: 1.2;
  position: absolute !important;
}

.card.selected > img {
  transform: rotateY(0);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.4);
}

.blur {
  pointer-events: none;
  filter: blur(10px);
}


.show-more-button {
  border-radius: 4px;
  background: #fff;
}

.product-card-fantasy-900-button {
  bottom: 50%;
  right: 25%;
}
</style>